import React from 'react'
import PropTypes from 'prop-types'

import { Content } from './styles'

function Image(props) {
  return <Content {...props} />
}

Image.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
}

export default Image
